module.exports = __WEBPACK_EXTERNAL_MODULE_113__;


//////////////////
// WEBPACK FOOTER
// external "rxjs/add/operator/map"
// module id = 113
// module chunks = 0